import { getAPIWithRethrow, postAPI, putAPI } from "../utils/apiService";

export const getVariables = async (projectId: $TSFixMe) =>
  await getAPIWithRethrow(`/v2/variables?projectId=${projectId}`);

export const createVariable = async (payload: $TSFixMe) => await postAPI("/v2/variables", payload);

export const updateVariable = async (payload: $TSFixMe, variableId: $TSFixMe) =>
  await putAPI(`/v2/variables/${variableId}`, payload);
